import { Component, input, output, signal } from '@angular/core';
import { DealCycle, DealResponse } from '../../models/deal.model';

@Component({
  selector: 'app-deal-close-reopen-modal',
  imports: [],
  templateUrl: './deal-close-reopen-modal.component.html',
})
export class DealCloseReOpenmModalComponent {
  visible = input<boolean>(false);
  action = input<string>();

  closed = output<void>();

  deal = input<DealResponse | null>(null);
  dealCycles = input<DealCycle[]>([]);

  closeDealInformation = output<{
    dealId: number;
    businessId: number;
    idDealCycle: number;
    description: string | undefined;
    action: string;
  }>();
  selectedDealCycle = signal<number | null>(null);
  notes = signal('');

  error = '';

  close() {
    this.notes.set('');
    this.closed.emit();
    this.error = '';
    this.selectedDealCycle.set(null);
  }

  filterCycles() {
    if (this.action() !== 'Cerrar') {
      const reOpenDealCycles = this.dealCycles().filter(
        (cycle) => !cycle.name.toLowerCase().includes('cierre'),
      );
      return reOpenDealCycles;
    }
    const closeDealCycles = this.dealCycles().filter((cycle) =>
      cycle.name.toLowerCase().includes('cierre'),
    );
    return closeDealCycles;
  }

  confirm() {
    const deal = this.deal();
    const closeType = this.selectedDealCycle();

    if (!deal?.id) return;
    if (!closeType) {
      this.error = 'Debe seleccionar una etapa para continuar';
      return;
    }

    this.closeDealInformation.emit({
      dealId: deal.id,
      businessId: deal.businessId,
      idDealCycle: closeType,
      description: this.notes(),
      action: this.action()!,
    });
    this.notes.set('');
    this.selectedDealCycle.set(null);
  }

  changeDealCycle(event: Event) {
    this.error = '';
    const value = Number((event.target as HTMLSelectElement).value);
    this.selectedDealCycle.set(value);
  }

  onNotesChange(event: Event): void {
    const value = (event.target as HTMLTextAreaElement).value;
    this.notes.set(value);
  }
}
